var _a, _b;
import { api, apis } from 'api';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
const loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
const systemApi = api.getSystemApi();
const feedbackApi = api.requireLogicalApi(apis.feedbackApiImpl);
const inElectron = systemApi.isElectron();
const isMac = inElectron && ((_b = (_a = window.electronLib) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.isMac);
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const platform = inElectron ? (isMac ? 'mac' : 'win') : 'web';
export const feedbackUploadLog = async () => {
    var _a, _b, _c, _d, _e, _f;
    const userEmail = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
    let fileName = `clieng-log/sirius/${platform}/${userEmail}/${Date.now()}-0`;
    let logFile = null;
    if (inElectron) {
        const electronRes = await ((_c = (_b = window.electronLib) === null || _b === void 0 ? void 0 : _b.fsManage) === null || _c === void 0 ? void 0 : _c.logsToArrayBuf());
        fileName = `${fileName}.zip`;
        logFile = new File([electronRes === null || electronRes === void 0 ? void 0 : electronRes.data], fileName, { type: 'application/zip' });
    }
    else {
        const blob = await loggerApi.getWebLogs();
        fileName = `${fileName}.log`;
        logFile = new File([...blob.values()], fileName);
    }
    const type = 'log';
    const user = systemApi.getCurrentUser();
    const ua = navigator.userAgent.toLowerCase();
    const os = ua.indexOf('windows') > -1 ? 'win' : ua.indexOf('mac') > -1 ? 'mac' : 'others';
    if (!userEmail) {
        SiriusMessage.error({ content: '上传失败，请稍后重试' });
        return false;
    }
    let orgId = ((_d = user === null || user === void 0 ? void 0 : user.contact) === null || _d === void 0 ? void 0 : _d.contact.enterpriseId) || ((_f = (_e = user === null || user === void 0 ? void 0 : user.prop) === null || _e === void 0 ? void 0 : _e.companyId) === null || _f === void 0 ? void 0 : _f.split('_').pop());
    if (!orgId) {
        try {
            const getOrgIdFromUser = contactApi
                .doGetContactByItem({
                type: 'EMAIL',
                value: [userEmail],
            })
                .then(([contact]) => {
                return contact.contact.enterpriseId ? String(contact.contact.enterpriseId) : contact.contact.enterpriseId;
            });
            const getOrgIdFromOrg = contactApi.doGetOrgList({ typeList: [99] }).then(([org]) => {
                return org.originId.split('_').pop();
            });
            orgId = await Promise.any([getOrgIdFromOrg, getOrgIdFromUser]);
        }
        catch (e) {
            console.warn(e);
        }
    }
    if (!orgId) {
        SiriusMessage.error({ content: '上传失败，请稍后重试' });
        return false;
    }
    try {
        const res = await loggerApi.uploadNosMediaOrLog(logFile, fileName, type);
        const deviceInfo = await systemApi.getDeviceInfo();
        if (res === 'success') {
            const params = {
                email: userEmail || '',
                productId: systemApi.inEdm() ? 'fastmail' : deviceInfo.p === 'web' ? 'sirius' : deviceInfo.p,
                deviceId: deviceInfo._deviceId,
                platform,
                version: window.siriusVersion,
                system: inElectron ? platform : os,
                systemVersion: deviceInfo._systemVersion,
                ua: navigator.userAgent,
                orgId: String(orgId),
                orgName: user === null || user === void 0 ? void 0 : user.company,
                feedbackType: 'one_click',
                files: [
                    {
                        type,
                        name: fileName,
                        size: logFile.size,
                        fileCreateTime: Date.now(),
                    },
                ],
            };
            if (platform === 'web') {
                const browserInfo = systemApi.getBrowserInfo();
                params.browser = browserInfo.name;
                params.browserVersion = browserInfo.version;
            }
            const feedbackRes = await feedbackApi.submitFeedback(params);
            if (feedbackRes.success) {
                SiriusMessage.success({ content: getIn18Text('SHANGCHUANCHENGGONG') });
                return feedbackRes.success;
            }
        }
    }
    catch (e) {
        console.warn(e);
    }
    SiriusMessage.error({ content: getIn18Text('SHANGCHUANSHIBAI') });
    return false;
};
